<h3 mat-dialog-title class="title-modal">{{ data.titulo }}</h3>
<div mat-dialog-content>
    <form [formGroup]="filtrosForm" style="width: 100%">
        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
                <mat-label>Cliente</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinner"></mat-spinner>
                    <input
                        matInput
                        placeholder="Digite o nome ou conta de um cliente"
                        aria-label="Cliente"
                        formControlName="cliente_id"
                        [matAutocomplete]="auto"
                    />
                </div>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let cliente of filteredClientOptions | async" [value]="cliente.id.toString()">
                        <span> {{ cliente.nome }}</span> |
                        <small>Conta: {{ cliente.numero_xp }}</small>
                    </mat-option>
                </mat-autocomplete>
                <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.status_boleta">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
                <mat-label>Status</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerStatus"></mat-spinner>
                    <mat-select placeholder="Selecione o status" formControlName="status_id">
                        <mat-option value="">Selecione..</mat-option>
                        <mat-option value="TODOS">Todos</mat-option>
                        <mat-option *ngFor="let status of listStatus" [value]="status.id">{{ status.nome }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.status_ordem">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
                <mat-label>Status</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerStatus"></mat-spinner>
                    <mat-select placeholder="Selecione o status" formControlName="status_ordem_id">
                        <mat-option value="">Todos</mat-option>
                        <mat-option *ngFor="let status of listStatusOrdem" [value]="status.id">{{
                            status.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="space-between" fxLayout.gt-md="row" *ngIf="config.produto">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Produto</mat-label>
                <!--todo: verificar    (selectionChange)="selectRoa($event)"-->
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerProduto"></mat-spinner>
                    <mat-select placeholder="Selecione o produto" formControlName="produto_id">
                        <mat-option *ngFor="let produto of listProduto" [value]="produto.id">{{
                            produto.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.compraVenda">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Tipo Operação</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerTipo"></mat-spinner>
                    <mat-select placeholder="Selecione o Tipo Operação" formControlName="compra_venda">
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option value="COMPRA">COMPRA</mat-option>
                        <mat-option value="VENDA">VENDA</mat-option>
                        <mat-option value="COMPRA/VENDA">COMPRA/VENDA</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.status_ordem">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Ativos</mat-label>
                <input matInput placeholder="BBDC4, B3SA3, ...." formControlName="ativos" maxlength="255" />
            </mat-form-field>
        </div>

        <div
            fxLayout="column"
            fxLayout.gt-md="row"
            fxLayoutAlign="space-between"
            *ngIf="config.dateLabel === 'operacao'"
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data da Operação Início</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="data_operacao_inicio"
                    placeholder="Data da Operação"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data da Operação Fim</mat-label>
                <input
                    matInput
                    [matDatepicker]="pickerFim"
                    formControlName="data_operacao_fim"
                    placeholder="Data da Operação"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                <mat-datepicker #pickerFim></mat-datepicker>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.dataAtualizacao">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Atualização Início</mat-label>
                <input matInput [matDatepicker]="picker_atualizacao_inicio" formControlName="data_atualizacao_inicio" placeholder="Data de Atualização Início" />
                <mat-datepicker-toggle matSuffix [for]="picker_atualizacao_inicio"></mat-datepicker-toggle>
                <mat-datepicker #picker_atualizacao_inicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Atualização Fim</mat-label>
                <input matInput [matDatepicker]="picker_atualizacao_fim" formControlName="data_atualizacao_fim" placeholder="Data de Atualização Fim" />
                <mat-datepicker-toggle matSuffix [for]="picker_atualizacao_fim"></mat-datepicker-toggle>
                <mat-datepicker #picker_atualizacao_fim></mat-datepicker>
            </mat-form-field>
        </div>

        <div
            fxLayout="column"
            fxLayout.gt-md="row"
            fxLayoutAlign="space-between"
            *ngIf="config.dateLabel === 'fechamento'"
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data da Fechamento Início</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="data_operacao_inicio"
                    placeholder="Data da Operação"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data da Fechamento Fim</mat-label>
                <input
                    matInput
                    [matDatepicker]="pickerFim"
                    formControlName="data_operacao_fim"
                    placeholder="Data da Operação"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                <mat-datepicker #pickerFim></mat-datepicker>
            </mat-form-field>
        </div>

        <div
            fxLayout="column"
            fxLayoutAlign="start"
            fxLayout.gt-md="row"
            *ngIf="
                usuario.role_id == UserRole.ADMINISTRADOR_SISTEMAS ||
                usuario.role_id == UserRole.SOCIO_OPERADOR_RENDA_VARIAVEL ||
                usuario.role_id == UserRole.SOCIO_DIRETOR_ESPECIALISTA_RENDA_VARIAVEL ||
                usuario.role_id == UserRole.SOCIO_DIRETOR_LIDER_REGIONAL
            "
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Escritório</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerEscritorio"></mat-spinner>
                    <mat-select
                        placeholder="Selecione o escritório"
                        formControlName="escritorio_id"
                        (selectionChange)="selectEscritorio($event)"
                    >
                        <mat-option value="">TODOS</mat-option>
                        <mat-option *ngFor="let escritorio of listEscritorios" [value]="escritorio.id">{{
                            escritorio.nome_fantasia
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div
            fxLayout="column"
            fxLayoutAlign="start"
            fxLayout.gt-md="row"
            *ngIf="usuario.role_id != UserRole.SOCIO_ASSESSOR"
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Assessor</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                    <mat-select placeholder="Selecione o assessor" formControlName="assessor_id">
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{
                            assessor.name
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="config.parceiroConsorcio">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Parceiro</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerParceiroConsorcio"></mat-spinner>
                    <mat-select placeholder="Selecione o parceiro" formControlName="parceiro_consorcio_id">
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let parceiro of listParceiroConsorcio" [value]="parceiro.id">{{
                            parceiro.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.homebroker">
            <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>Cliente Home Broker</mat-label>
                <mat-select matNativeControl formControlName="homebroker">
                    <mat-option value="">Todos</mat-option>
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>Ação Comercial</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerAcaoComercial"></mat-spinner>
                    <mat-select formControlName="acao_comercial_id">
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option *ngFor="let acaoComercial of listAcaoComercial" [value]="acaoComercial.id">{{
                            acaoComercial.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.tipoConsorcio">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                <mat-label>Tipo Operação</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerTipo"></mat-spinner>
                    <mat-select placeholder="Selecione o Tipo Operação" formControlName="tipo_consorcio_id" >
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option *ngFor="let item of listTipoConsorcio" [value]="item.id">{{
                            item.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="48">
                <mat-label>Tipo Lance</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerTipoLance"></mat-spinner>
                    <mat-select placeholder="Selecione o Tipo Lance" formControlName="tipo_lance_id" >
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option *ngFor="let item of listTipoLance" [value]="item.id">{{ item.nome }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.classificacao">
            <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>Classficação</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerClassificacao"></mat-spinner>
                    <mat-select placeholder="Classficação do Cliente" formControlName="primeiro_contato_id">
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let classificacao of listClassificacao" [value]="classificacao.id">
                            {{ classificacao.nome }}
                        </mat-option>
                    </mat-select>
                </div>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="49">
                <mat-label>Estratégia</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerEstrategia"></mat-spinner>
                    <mat-select placeholder="Estrategias de Renda Variável" formControlName="estrategia_id">
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let estrategia of listEstrategia" [value]="estrategia.id">
                            {{ estrategia.nome }}
                        </mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.prazoPlanoSaude">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Prazo</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerPrazo"></mat-spinner>
                    <mat-select placeholder="Selecione o prazo" formControlName="prazo_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let prazo of listPrazo" [value]="prazo.id">{{ prazo.nome }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Tipo Operação</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerTipoOperacao"></mat-spinner>
                    <mat-select placeholder="Tipo Operação" formControlName="tipo_operacao_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let tipoOperacao of listTipoOperacao" [value]="tipoOperacao.id">{{
                            tipoOperacao.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.parceiroPlanoSaude">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Parceiro</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerParceiro"></mat-spinner>
                    <mat-select placeholder="Selecione o parceiro" formControlName="parceiro_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let parceiro of listParceiro" [value]="parceiro.id">{{
                            parceiro.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <!-- PLANO_SAUDE: mat-select -->
        <div
            fxLayout="column"
            fxLayoutAlign="start"
            fxLayout.gt-md="row"
            *ngIf="data.tipo === TipoInvestimento.PLANO_SAUDE"
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Responsável</mat-label>
                <div class="flex-row-center">
                    <mat-spinner
                        diameter="20"
                        class="loading-mr"
                        *ngIf="loadingSpinnerOperadorPlanoSaude"
                    ></mat-spinner>
                    <mat-select placeholder="Selecione o responsável" formControlName="operador_id">
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let operador of listOperador" [value]="operador.id">{{
                            operador.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>

        <!-- Não-PLANO_SAUDE: mat-autocomplete -->
        <div
            fxLayout="column"
            fxLayoutAlign="start"
            fxLayout.gt-md="row"
            *ngIf="data.tipo !== TipoInvestimento.PLANO_SAUDE"
        >
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Responsável</mat-label>
                <div class="flex-row-center">
                    <mat-spinner
                        diameter="20"
                        class="loading-mr"
                        *ngIf="loadingSpinnerOperadorAutocomplete"
                    ></mat-spinner>
                    <input
                        matInput
                        placeholder="Digite o nome do responsável"
                        formControlName="operador_id"
                        [matAutocomplete]="autoOperador"
                    />
                </div>
                <mat-autocomplete #autoOperador="matAutocomplete" [displayWith]="displayOperadorFn">
                    <mat-option
                        *ngFor="let operador of filteredOperadorOptions | async"
                        [value]="operador.id?.toString()"
                    >
                        {{ operador.nome }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.dataRetorno">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Retorno Início</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker_data_retorno_inicio"
                    formControlName="data_retorno_inicio"
                    placeholder="Data de Retorno Início"
                />
                <mat-datepicker-toggle matSuffix [for]="picker_data_retorno_inicio"></mat-datepicker-toggle>
                <mat-datepicker #picker_data_retorno_inicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Retorno Fim</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker_data_retorno_fim"
                    formControlName="data_retorno_fim"
                    placeholder="Data de Retorno Fim"
                />
                <mat-datepicker-toggle matSuffix [for]="picker_data_retorno_fim"></mat-datepicker-toggle>
                <mat-datepicker #picker_data_retorno_fim></mat-datepicker>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.prazoCredito">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Prazo</mat-label>
                <input matInput placeholder="Selecione o prazo" formControlName="prazo_credito" maxlength="255" />
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Tipo Operação</mat-label>
                <div class="flex-row-center">
                    <mat-spinner
                        diameter="20"
                        class="loading-mr"
                        *ngIf="loadingSpinnerTipoOperacaoCredito"
                    ></mat-spinner>
                    <mat-select placeholder="Tipo Operação" formControlName="tipo_operacao_credito_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let tipoOperacao of listTipoOperacaoCredito" [value]="tipoOperacao.id">{{
                            tipoOperacao.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between" *ngIf="config.parceiroCredito">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Parceiro</mat-label>
                <div class="flex-row-center">
                    <mat-spinner diameter="20" class="loading-mr" *ngIf="loadingSpinnerParceiroCredito"></mat-spinner>
                    <mat-select placeholder="Selecione o parceiro" formControlName="parceiro_credito_id" >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let parceiroCredito of listParceiroCredito" [value]="parceiroCredito.id">{{
                            parceiroCredito.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Tabela de Comissionamento</mat-label>
                <div class="flex-row-center">
                    <mat-spinner
                        diameter="20"
                        class="loading-mr"
                        *ngIf="loadingSpinnerTabelaComissionamentoCredito"
                    ></mat-spinner>
                    <mat-select
                        placeholder="Tabela de Comissionamento"
                        formControlName="tabela_comissionamento_id"
                        
                    >
                        <mat-option value="">Selecione...</mat-option>
                        <mat-option *ngFor="let tabela of listTabelaComissionamentoCredito" [value]="tabela.id">{{
                            tabela.nome
                        }}</mat-option>
                    </mat-select>
                </div>
            </mat-form-field>
        </div>
    </form>
</div>
<div mat-dialog-actions class="dialog-actions-v2">
    <button
        mat-button
        (click)="limpar()"
        [disabled]="!hasValidFilters"
        *ngIf="config.limparFiltrosButton"
        data-testid="limpar-filtros-button"
    >
        Limpar filtros
    </button>
    <button mat-button (click)="fecharModal()" [color]="'warn'" data-testid="cancelar-button">Cancelar</button>
    <button mat-button (click)="filtrar()" class="filtrar-button" data-testid="filtrar-button">Filtrar</button>
</div>
